// Google Drive service - uses serverless function to keep API key secure

export const fetchImagesFromFolder = async (folderId) => {
  if (!folderId) {
    console.error('Folder ID is required');
    return [];
  }

  try {
    // Use Netlify serverless function to proxy the request
    // This keeps the API key secure on the server side
    const response = await fetch(
      `/api/getGoogleDriveFiles?folder_id=${encodeURIComponent(folderId)}`
    );
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data.files || [];
  } catch (error) {
    console.error('Error fetching images from Google Drive:', error);
    return [];
  }
};

export const getImageUrl = (fileId) => {
  return `https://drive.google.com/uc?export=view&id=${fileId}`;
};

export const getAlternativeImageUrls = (fileId) => {
  return [
    `https://drive.google.com/uc?export=view&id=${fileId}`,
    `https://drive.google.com/thumbnail?id=${fileId}&sz=w1200`,
    `https://drive.google.com/thumbnail?id=${fileId}&sz=w1920`,
    `https://lh3.googleusercontent.com/d/${fileId}`,
    `https://drive.google.com/uc?export=download&id=${fileId}`,
  ];
};

export const getVideoUrl = (fileId) => {
  return `https://drive.google.com/file/d/${fileId}/preview`;
};
